import { Platform } from 'react-native'

interface ThemeColors {
    textPrimary: string
    textSecondary: string
    colorPrimary: string
    colorSecondary: string
    colorTertiary: string
    colorApprovedEvaluation: string
    colorApproved: string
    colorCancelled: string
    colorPending: string
    colorInProgress: string
    colorLocked: string
    colorSeen: string
    colorRetry: string
    colorDisapproved: string
    error: string
    alert: string
    disabled: string
    background: string
    modalBackground: string
    formsBackground: string
    filtersBackground: string
    linearGradientStart: string
    linearGradientEnd: string
    linearGradientGreenStart: string
    linearGradientGreenEnd: string
    linearGradientRedStart: string
    linearGradientRedEnd: string
    neutralGray: string
    lightGray: string
    mediumGray: string
    darkGray: string
    colorHeart: string
    colorComment: string
    colorShare: string
    gamificationDotApprovedColor: string
    pageIndicatorBackground: string
    RankingFirstPlaceColor: string
    RankingSecondPlaceColor: string
    RankingThirdPlaceColor: string
    RankingPointsColor: string
    createScheduleBackgroundColor: string
    vacationDaySelectedColor: string
    floatPageIndicatorBackground: string
    storeFormButtonBackground: string
    storeItemTextAddressStoreWithGoTo: string

    //indicadores de tienda
    linearGradientStart00: string
    linearGradientEnd00: string
    linearGradientStart01: string
    linearGradientEnd01: string
    linearGradientStart02: string
    linearGradientEnd02: string
    linearGradientStart03: string
    linearGradientEnd03: string
    linearGradientStart04: string
    linearGradientEnd04: string
}

interface ThemeFontSizes {
    ultraBigText: number
    bigText: number
    normalText: number
    mediumText: number
    smallText: number
    ultraSmallText: number
}

interface ThemeFonts {
    main: string
}

interface ThemeFontWeights {
    light: string
    normal: string
    bold: string
}

interface ThemeFontStyles {
    normal: string
    italic: string
}

interface Theme {
    colors: ThemeColors
    fontSizes: ThemeFontSizes
    fonts: ThemeFonts
    fontWeights: ThemeFontWeights
    fontStyles: ThemeFontStyles
}

const theme: Theme = {
    colors: {
        textPrimary: '#171824',
        textSecondary: '#727293',
        colorPrimary: '#003FE2',
        colorSecondary: '#0095FF',
        colorTertiary: '#F68B32',
        colorApprovedEvaluation: '#08AC17',
        colorApproved: '#088834',
        colorCancelled: '#E51D0D',
        colorPending: '#95919F',
        colorInProgress: '#FFA500',
        colorLocked: '#727293',
        colorSeen: '#1C8CF7',
        colorRetry: '#E51D0D',
        colorDisapproved: '#E51D0D',
        error: '#E51D0D',
        alert: '#FFDE39',
        disabled: '#DDDBE2',
        background: '#FFFFFF',
        modalBackground: '#F9FAFE',
        formsBackground: '#F1F2FF',
        filtersBackground: '#F1F2FF',
        linearGradientStart: '#003FE2',
        linearGradientEnd: '#0095FF',
        linearGradientGreenStart: '#16823F',
        linearGradientGreenEnd: '#028754',
        linearGradientRedStart: '#C21818',
        linearGradientRedEnd: '#DA2121',
        neutralGray: '#DADADA',
        lightGray: '#D6D9EB',
        mediumGray: '#A7A5C5',
        darkGray: '#727293',
        colorHeart: '#E51D0D',
        colorComment: '#1C8CF7',
        colorShare: '#09B348',
        gamificationDotApprovedColor: '#53D06F',
        pageIndicatorBackground: '#FAFAFA',
        RankingFirstPlaceColor: '#E2BA61',
        RankingSecondPlaceColor: '#666666',
        RankingThirdPlaceColor: '#ED713B',
        RankingPointsColor: '#1C98F0',
        createScheduleBackgroundColor: '#E53935',
        vacationDaySelectedColor: '#141319',
        floatPageIndicatorBackground: '#FAFAFA',
        storeFormButtonBackground: '#F1F2FF',
        storeItemTextAddressStoreWithGoTo: '#6D85DA',
        linearGradientStart00: '#645FF9',
        linearGradientEnd00: '#1A3BB1',
        linearGradientStart01: '#1A3BB1',
        linearGradientEnd01: '#2A287A',
        linearGradientStart02: '#2A287A',
        linearGradientEnd02: '#21273A',
        linearGradientStart03: '#0E0E2C',
        linearGradientEnd03: '#0E0E2C',
        linearGradientStart04: '#171D35',
        linearGradientEnd04: '#6560FA',
    },
    fontSizes: {
        ultraBigText: 18,
        bigText: 16,
        normalText: 15,
        mediumText: 14,
        smallText: 13,
        ultraSmallText: 12,
    },
    fonts: {
        main: Platform.select({
            android: 'System',
            ios: 'System',
            default: 'System',
        }) as string,
    },
    fontWeights: {
        light: '300',
        normal: '400',
        bold: '700',
    },
    fontStyles: {
        normal: 'normal',
        italic: 'italic',
    },
}

export default theme
export type { Theme, ThemeColors, ThemeFontSizes, ThemeFonts, ThemeFontWeights, ThemeFontStyles }
